import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";

import dashboard from "./slices/dashboard";

export const store = configureStore({
  reducer: {
    dashboard: dashboard,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
